import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "cta__inner" }
const _hoisted_2 = {
  key: 0,
  class: "cta__title"
}
const _hoisted_3 = {
  key: 1,
  class: "cta__text"
}

import type { RouteLocationRaw } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'PaywallCTA',
  props: {
    to: {},
    variant: { default: 'default' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["cta", `cta--${__props.variant}`])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.$slots.title)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_2, [
            _renderSlot(_ctx.$slots, "title")
          ]))
        : _createCommentVNode("", true),
      (_ctx.$slots.description)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "description")
          ]))
        : _createCommentVNode("", true),
      (_ctx.$slots.button)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: __props.to ?? { name: 'signup' },
            class: "button button--theme button--size-m cta__button"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "button", {}, () => [
                _cache[0] || (_cache[0] = _createTextVNode("Sign up for free", -1))
              ])
            ]),
            _: 3
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})